"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_CardMedia.default, props, children);
};

var _default = CardMedia;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZE1lZGlhLnRzeCJdLCJuYW1lcyI6WyJDYXJkTWVkaWEiLCJjaGlsZHJlbiIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7OztBQUdBLElBQU1BLFNBQW1DLEdBQUcsU0FBdENBLFNBQXNDO0FBQUEsTUFBR0MsUUFBSCxRQUFHQSxRQUFIO0FBQUEsTUFBZ0JDLEtBQWhCOztBQUFBLHNCQUMxQyw2QkFBQyxrQkFBRCxFQUFrQkEsS0FBbEIsRUFBMEJELFFBQTFCLENBRDBDO0FBQUEsQ0FBNUM7O2VBSWVELFMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ2FyZE1lZGlhIGFzIE11aUNhcmRNZWRpYSwgQ2FyZE1lZGlhUHJvcHMgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZSc7XG5cbmNvbnN0IENhcmRNZWRpYTogUmVhY3QuRkM8Q2FyZE1lZGlhUHJvcHM+ID0gKHsgY2hpbGRyZW4sIC4uLnByb3BzIH0pID0+IChcbiAgPE11aUNhcmRNZWRpYSB7Li4ucHJvcHN9PntjaGlsZHJlbn08L011aUNhcmRNZWRpYT5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IENhcmRNZWRpYTtcbiJdfQ==